import type { IOrgInfoVm } from '@/types/IOrgInfoVm'
import { defineStore } from 'pinia'

export const useAuthStore = defineStore({
  id: 'authstore',
  state: () => ({
    rootUrl: '/api/Participation/',
    isAuthenticated: false,
    isClubhouseUser: false,
    isOrgUser: false,
    isNationalAssociationUser: false,
    displayName: '',
    clubId: undefined,
    clubUID: '',
    isVirtualClub: false,
    associationId: undefined,
    associationRegionId: undefined,
    orgInfo: null as any,
    isLoadingLogin: true,
    liveUrl: '',
    orgUrl: ''
  }),
  getters: {
    authenticated: (state) => {
      return () => {
        return state.isAuthenticated
      }
    }
  },
  actions: {
    async authenticate() {
      const syncQueryParam = 'ssoSyncDone'
      const currentUrl = new URL(location.href)
      const hasCompletedSync = currentUrl.searchParams.get(syncQueryParam) === '1'

      if (!hasCompletedSync) {
        const returnUrl = new URL(currentUrl.toString())
        returnUrl.searchParams.set(syncQueryParam, '1')
        location.href = `/api/auth/login?forceSso=true&r=${encodeURIComponent(returnUrl.toString())}`
        return
      }

      const returnUrl = location.href;

      const response = await this.axiosFactory
        .withoutToken()
        .get(`/api/auth/status?r=${encodeURI(returnUrl)}`)

      if (!response.data.isAuthenticated) {
        location.href = response.data.ssoUrl
      } else {
        this.isAuthenticated = true
        this.isClubhouseUser = response.data.isClubhouseUser
        this.isOrgUser = response.data.isOrgUser
        this.isNationalAssociationUser = response.data.isNationalAssociationUser
        this.clubId = response.data.clubId ?? undefined
        this.clubUID = response.data.clubUID ?? ''
        this.associationId = response.data.associationId ?? undefined
        this.associationRegionId = response.data.associationRegionId ?? undefined
        this.liveUrl = response.data.liveUrl ?? undefined
        this.orgUrl = response.data.orgUrl ?? undefined
        this.displayName = response.data.displayName ?? ''
        this.isVirtualClub = response.data.isVirtualClub;

        // Remove one-time sync marker so the next fresh app entry syncs again.
        currentUrl.searchParams.delete(syncQueryParam)
        history.replaceState({}, document.title, currentUrl.toString())
      }
    },
    async getLoginOrgInfo(): Promise<IOrgInfoVm | null> {
      if (this.orgInfo) {
        this.isLoadingLogin = false;
        return this.orgInfo
      }

      this.isLoadingLogin = true

      try {
        const response = await this.axiosFactory
          .withoutToken()
          .get(`${this.$state.rootUrl}GetLoginOrgInfo`)

        if (response.data) {
          this.orgInfo = response.data.data
        }
      } catch (error: any) {
        console.log('error', error.response)
      } finally {
        this.isLoadingLogin = false
      }

      return null
    }
  }
})
